import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import { IAboutProjectYeah, isLastIndex } from '../yeah.state'

interface IProjectInfoSectionProps {
    aboutProject: Array<IAboutProjectYeah>;
    title: string;
}
const ProjectInfoSectionYeah = ({ aboutProject, title }: IProjectInfoSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container} ${style.aboutProject}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${style.aboutProject__title} ${animations.scroll__animation} ${style.title_large} ${style.mr106}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.aboutProject__items}`}>
                    {
                        aboutProject.map((item: IAboutProjectYeah, index: number) => {
                            return (
                                <div className={`${style.aboutProject__item} ${isLastIndex(index, aboutProject.length) ? null : style.mb31}`} key={index}>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.title} ${style.mb8} ${style.title_small} ${animations.scroll__animation}`}>
                                                    {item.title}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.text} ${style.text_middle} ${animations.scroll__animation}`}>
                                                    {item.subtitle}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default ProjectInfoSectionYeah;
